<template>
  <b-modal hide-header id="modal_close_ticket" title="Motivo ticket">
    <h2 class="text-center" id="swal2-title">¿ Cancelar ticket ?</h2>
    <p class="lead text-center">¿Está seguro de realizar este proceso?</p>
    <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
      <div class="swal2-icon-content">!</div>
    </div>
    <b-form-group label="Motivo">
      <b-form-textarea
          id="textarea"
          v-model="observation"
          placeholder="Indica el motivo por el cúal deseas cerrar el ticket..."
          rows="3"
          max-rows="6"></b-form-textarea>
    </b-form-group>

    <template #modal-footer="{ cancel }">
      <b-button size="md" variant="primary" :disabled="!observation || observation.length <= 4"  @click="changeStatusTicket">
        Cerrar ticket
      </b-button>
      <b-button size="md" variant="danger" @click="cancel()">
        Cancelar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "ModalCloseTickect",
  props: ['ticket_detalle'],
  data(){
    return {
     observation: ''
    }
  },
  methods: {
    ...mapActions("tickets", ["cancelTicket"]),
    async changeStatusTicket() {
      this.ticket_detalle.observation = this.observation
      await this.cancelTicket(this.ticket_detalle).then(async ()=>{
        this.$bvModal.hide("modal_close_ticket");
      })
    }
  }
}
</script>

<style scoped>

</style>
